import { AnyMongoAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';
import { createContext } from 'react';

export const AbilityContext = createContext<AnyMongoAbility>(undefined!);

export default createContextualCan(AbilityContext.Consumer);
